
import {Vue, Component, PropSync} from 'vue-property-decorator';
import TeacherNotice from 'src/modules/teacher/TeacherNotice.vue';
import {openSubscribePage} from 'src/utils/NavigationUtils';
import {analyticsController} from 'src/modules/user/analytics/AnalyticsController';
import {getAssetItem} from 'src/utils/helpers';
import {type StripePrice, subscriptionService} from '../../user/subscription/SubscriptionService';
import {currentPromotion} from '../marketing/PromotionController';
import {userService} from '../../user/UserService';

@Component({
  components: {
    TeacherNotice,
  },
  methods: {
    getAssetItem,
  },
})
export default class FreemiumSubscriptionPopup extends Vue {
  private isDisplayed: boolean = false;
  private showBenefitsPopup: boolean = false;
  private promotion: number = 50;
  private isLoading: boolean = false;
  private slide: number = 1;
  private importMusicxmlPieceQuota: boolean = false;

  benefits = [
    {
      icon: 'mdi-infinity',
      text: 'Accès illimité à tous les contenus',
    },
    {
      icon: 'mdi-robot',
      text: 'Professeur virtuel personnalisé',
    },
    {
      icon: 'mdi-chart-line',
      text: 'Suivi détaillé de vos progrès',
    },
    {
      icon: 'mdi-file',
      text: 'Importez vos propres morceaux en illimité',
    }
  ];

  testimonials = [
    {
      name: 1,
      text: "Autodidacte depuis un an avec internet, je jouais surtout des morceaux juste à une main.. du coup là je suis content parce que les exercices me permettent de m'entraîner à jouer les 2 en même temps ce que j'arrivais pas à faire tout seul",
      author: "Pierre Dardenne, par mail à l'équipe Tokatab",
    },
    {
      name: 2,
      text: "J'aime beaucoup, surtout quand l'appli joue le son de l'autre main que je ne joue pas. C'est plus cool pour m'entrainer et c'est agreable à entendre",
      author: 'Posipi 83, sur le Play store',
    },
    {
      name: 3,
      text: "Votre méthode est efficace, mon jeu en accords à la main droite est bien meilleur que avant. Je joue avec aisance des morceaux que je pensais trop difficiles pour moi il y a encore quelques mois, comme par exemple georgia on my mind. Mon fils de 13 ans s'est fait aussi fait un compte et a fait de jolis progrès. Merci à toute l'équipe pour ce bon outil d'apprentissage !",
      author: "Marco78, par mail à l'équipe Tokatab",
    },
    {
      name: 4,
      text: "Top appli ! Pour avoir testé plusieurs appli concurrentes, Tokatab est de loin la meilleure en terme d'apprentissage technique du piano",
      author: 'Cassandre349, sur App store',
    },
    {
      name: 5,
      text: "Après 2 ans avec Tokatab j'ai sauté le cap et j'ai pris un prof, j'avais besoin de passer ce cap. Il a trouvé que mes mains avaient déjà de bons réflexes et a cru que j'avais déja pris des cours avant. Bref, merci à vous pour l'application et même si je prends des cours à coté, je continue bien sur ma routine de 2 à 3 sessions par semaine avec tokatab 😉",
      author: "Myriam, par mail à l'équipe Tokatab",
    },
    {
      name: 6,
      text: "Cela faisait plusieurs années que j'avais en projet, un jour, d'apprendre le piano. Finalement, à 40 ans, j'ai découvert presque par hasard l'appli Tokatab, créée par un prof de piano pour apprendre le piano. Le prix de l'abonnement est vraiment pas cher pour avoir un quasi prof de piano à la maison dispo 7/7 24/24. Les leçons sont progressives et m'ont permis d'avancer super vite en l'espace de 2-3 mois, je veux dire j'arrive à jouer avec 2 mains ! En plus on peut apprendre des morceaux ! Top!",
      author: "Sarah, par mail à l'équipe Tokatab",
    },
    {
      name: 7,
      text: "Parfait pour reprendre le piano à mon rythme. Après avoir pris des cours de piano dans ma jeunesse, Tokatab m'a permis de m'y remettre sans avoir à payer pour des cours en présentiel. Les leçons sont accessibles et adaptées à mon emploi du temps chargé. Une solution pratique et économique, j'adore 🙂",
      author: 'Fanny Therry, sur le Play store',
    },
    {
      name: 8,
      text: 'Contrairement aux autres applications, le vrai "plus" de Tokatab est que l\'app est pensée pour maîtriser son piano (avec des exercices, des maîtrises de certains gestes et positions…), et non pour uniquement jouer un morceau. Top !',
      author: 'HolivYeahhh, sur App store',
    },
    {
      name: 9,
      text: 'Très bonne appli, les exercices sont super!',
      author: 'Qiao Qiao, sur le Play store',
    },
  ];

  mounted() {
    this.$root.$on('displayFreemiumPopup', (importMusicxmlPieceQuota = false) => {
      this.isDisplayed = true;
      this.importMusicxmlPieceQuota = importMusicxmlPieceQuota;
      analyticsController.logBasicAnalyticsEvent('freemium popup displayed', 'Freemium');
    });
  }

  get monthlyPrice() {
    return subscriptionService.monthlyPrice;
  }
  get monthlyPriceHumanReadable() {
    return subscriptionService.humanizeUnitAmount(this.monthlyPrice);
  }
  get monthlyReductedPriceHumanReadable() {
    const reducedPrice: StripePrice = {
      ...this.monthlyPrice,
      unit_amount: this.monthlyPrice?.unit_amount * (1 - this.promotion / 100),
    };
    return subscriptionService.humanizeUnitAmount(reducedPrice);
  }
  get mainTitle() {
    if (this.importMusicxmlPieceQuota) {
      return 'Quota d\'import atteint';
    }
    return 'Contenus gratuits épuisés';
  }
  get mainSubtitle() {
    if (this.importMusicxmlPieceQuota) {
      return 'Importez vos propres morceaux en illimité avec un abonnement Premium.';
    }
    return 'Débloquez dès aujourd\'hui un apprentissage sans limite pour moins de 5€ par mois.';
  }
  get isLandscape() {
    return this.$q.screen.width > this.$q.screen.height;
  }
  get showAsActionPopup() {
    return this.$q.screen.gt.sm || this.$q.screen.width < this.$q.screen.height;
  }
  get nextSundayDate(): string {
    const now = new Date();
    const nextSunday = new Date(now);

    // Calculate days until next Monday (0 = Sunday, 1 = Monday, etc.)
    const daysUntilMonday = (8 - now.getDay()) % 7;
    const daysToAdd = daysUntilMonday === 0 ? 7 : daysUntilMonday;

    nextSunday.setDate(now.getDate() + daysToAdd);
    nextSunday.setHours(0, 0, 0, 0);

    // Format in French with proper capitalization
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    const formatted = nextSunday.toLocaleDateString('fr-FR', options);
    // Capitalize first letter
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }
  get tomorrowDate() {
    const now = new Date();
    const tomorrow = new Date(now);

    tomorrow.setDate(now.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    // Format in French with proper capitalization
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    const formatted = tomorrow.toLocaleDateString('fr-FR', options);
    // Capitalize first letter
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }
  get isUserIsInBPaymentGroup() {
    return userService.user.paymentGroupTesting === 'B';
  }

  showBenefits(): void {
    this.showBenefitsPopup = true;
    analyticsController.logBasicAnalyticsEvent('freemium popup benefits shown', 'Freemium');
  }
  closeBenefitsPopup(): void {
    this.showBenefitsPopup = false;
    analyticsController.logBasicAnalyticsEvent('freemium popup benefits closed', 'Freemium');
  }

  closePopup(): void {
    analyticsController.logBasicAnalyticsEvent('freemium popup closed', 'Freemium');
    this.isDisplayed = false;
  }

  goToSubscribe(): void {
    analyticsController.logBasicAnalyticsEvent('freemium popup subscribe clicked', 'Freemium');
    this.isDisplayed = false;
    openSubscribePage.bind(this)(this.$route.path, 'freemiumPopup', undefined, undefined, true);
  }

  subscribe(): void {
    this.isLoading = true;
    analyticsController.logBasicAnalyticsEvent('freemium popup subscribe for month clicked', 'Freemium');
    subscriptionService
      .redirectToCheckout(subscriptionService.monthlyPrice, currentPromotion, 'subscribe', true)
      .then((val) => {
        if (val === 'ios_purchase_success') {
          this.$router.push('/subscribe/success');
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
